import * as React from 'react';
import { Link } from 'react-router';
import { IconType, SvgIcon } from '../General/SvgIcon';
import styled, { keyframes } from 'styled-components';
import { rem, darken, rgba } from 'polished';
import { prop } from '../../../utilities';

export interface Props {
  isFavorite: boolean;
  isHovered: boolean;
  toggleFavourite: any;
}

function FavoriteCompare({ isFavorite, isHovered, toggleFavourite }: Props) {
  const [isHoverFav, setIsHoverFav] = React.useState(false);
  const [isHoverComp, setIsHoverComp] = React.useState(false);

  const onSetIsHoverFav = e => {
    setIsHoverFav(true);
  };
  const offSetIsHoverFav = e => {
    setIsHoverFav(false);
  };

  const onSetIsHoverComp = e => {
    setIsHoverComp(true);
  };
  const offSetIsHoverComp = e => {
    setIsHoverComp(false);
  };

  return (
    <Wrapper>
      {/* <StyledLink
        to={''}
        onMouseEnter={onSetIsHoverComp}
        onMouseLeave={offSetIsHoverComp}
      >
        <SvgIcon
          icon={IconType.compare}
          fill={isHoverComp ? '#000000' : '#DDDDDD'}
        />
      </StyledLink> */}
      <StyledLink to={''} isFavorite={isFavorite} isHovered={isHovered}>
        <StyledSvgIcon
          icon={IconType.favourite}
          width={24}
          height={24}
          viewBox="0 0 24 24"
          cursor="pointer"
          onClick={toggleFavourite}
        />
      </StyledLink>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const StyledLink = styled(Link)<{ isFavorite: boolean; isHovered: boolean }>`
  ${({ isFavorite, isHovered, theme }) => `
    opacity: ${isFavorite || isHovered ? `1` : `0`};

    ${
      !isFavorite && isHovered
        ? `
      svg {
        fill: ${rgba(theme.colors.textPrimary, 0.3)} !important;
      }
    `
        : ``
    }
  `}
`;

const StyledSvgIcon = styled(SvgIcon)`
  * {
    fill: inherit;
  }
`;

export { FavoriteCompare };
